export const defaultStationName = 'WeatherBug';
export const defaultTextValue = '--';